import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Button, Panel, Stack } from 'rsuite'

import useRFQModal from '../../Modals/hooks/useRFQModal'
import useGetAnalyticsLocation from '../../../services/analytics/useGetAnalyticsLocation'
import { AnalyticsSubLocation } from '../../../utils/types/analytics'

import buttonStyles from '../../../styles/CustomButtons.module.less'
import styles from '../../../styles/CatalogBottomSection.module.less'

const RfqSection: FC = () => {
  const analyticsLocation = useGetAnalyticsLocation(AnalyticsSubLocation.Banner)
  const openRfqModal = useRFQModal({ analyticsLocation })

  const { t } = useTranslation('products')

  return (
    <Panel
      bordered
      className={`${styles['rfq-section']} align-middle text-center`}
    >
      <Stack
        spacing={15}
        direction="column"
      >
        <div className="h2">{t('modals:Request a quote')}</div>
        <p>
          {t('List products you’re looking for and we’ll find the best products and prices for you – all for free')}
        </p>
        <Button
          appearance="primary"
          className={`${buttonStyles['custom-button']}
          ${buttonStyles['button-primary']}
          ${buttonStyles['button-caret']}
          `}
          size="lg"
          onClick={() => openRfqModal()}
        >
          {t('Request a quote')}
        </Button>
      </Stack>
    </Panel>
  )
}

export default RfqSection
